// src/slices/sponsor/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getSponsors, getSponsorById, addSponsor } from "./thunk";

const initialState = { sponsors: [], sponsor: null, loading: false, error: null, addLoading: false, addSuccess: false };

const sponsorSlice = createSlice({
  name: "sponsor",
  initialState,
  reducers: {
    clearSponsor: (state) => {
      state.sponsor = null;
    },
    resetAddSponsorState: (state) => {
      state.addLoading = false;
      state.addSuccess = false;
      state.error = null;
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getSponsors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSponsors.fulfilled, (state, action) => {
        state.loading = false;
        state.sponsors = action.payload?.data || action.payload;
      })
      .addCase(getSponsors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY ID =================
      .addCase(getSponsorById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSponsorById.fulfilled, (state, action) => {
        state.loading = false;
        state.sponsor = action.payload?.data || action.payload;
      })
      .addCase(getSponsorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= ADD SPONSOR =================
      .addCase(addSponsor.pending, (state) => {
        state.addLoading = true;
        state.addSuccess = false;
        state.error = null;
      })
      .addCase(addSponsor.fulfilled, (state, action) => {
        state.addLoading = false;
        state.addSuccess = true;

        state.sponsors.unshift(action.payload?.data || action.payload);
      })
      .addCase(addSponsor.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      });
  }
});

export const { clearSponsor, resetAddSponsorState } = sponsorSlice.actions;
export default sponsorSlice.reducer;
